var modulusSquared = function(c) {
	return c.i * c.i + c.r * c.r;
}

var add = function(a, b) {
	return { r: a.r + b.r, i: a.i + b.i };
}

var multiply = function(a, b) {
	return { r: a.r * b.r - a.i * b.i, i: a.r * b.i + a.i * b.r };
}

var square = function(z) {
	return { r: (z.r + z.i) * (z.r - z.i), i: 2 * z.i * z.r };
}

var pixelToComplex=function(horizontal, vertical, dimensions, centre, scale) {
	var z = {
		r: ((horizontal / dimensions.height) * 4 / scale) - (2 / scale - centre.r), //modified for ease of using vertical strips
		i: (2 / scale + centre.i) - ((vertical / dimensions.height) * 4 / scale) 
	};
	return z;
}

export default {
	modulusSquared,
	add,
	square,
	multiply,
	pixelToComplex
}